import React from 'react';
import styled from 'styled-components/macro';

import Sunflower from './collections/Sunflower';
import Hands from './collections/Hands';
import AutumnFlower from './collections/AutumnFlower';
import Bee from './collections/Bee';
import Rosemary from './collections/Rosemary';
import Tonica from './collections/Tonica';
import Ice from './collections/Ice';

import Apple from './collections/fruits/Apple';
import Blackberry from './collections/fruits/Blackberry';
import Blueberry from './collections/fruits/Blueberry';
import Elderflower from './collections/fruits/Elderflower';
import Mango from './collections/fruits/Mango';
import Pear from './collections/fruits/Pear';
import RedRhubarb from './collections/fruits/RedRhubarb';
import Watermelon from './collections/fruits/Watermelon';
import Wonderful from './collections/Wonderful';

const Wrapper = styled.div`
  position: absolute;
  z-index: 1;

  width: 100%;
`;

const Images = () => (
  <Wrapper>
    <Sunflower />
    <Bee />
    <Rosemary />
    <Tonica />
    <Wonderful />
    <Hands />
    <AutumnFlower />
    <Ice />

    <Apple />
    <Blackberry />
    <Blueberry />
    <Elderflower />
    <Mango />
    <Pear />
    <RedRhubarb />
    <Watermelon />
  </Wrapper>
);


export default Images;